import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [open, setOpen] = useState(false);

  // helper to close menu
  const handleLinkClick = () => setOpen(false);

  return (
    <nav className="navbar">
      <div className="navbar__inner">
        <Link to="/" className="navbar__brand" onClick={handleLinkClick}>
          FotoMate<sup>&reg;</sup>
        </Link>

        <button
          className={`navbar__hamburger${open ? ' is-open' : ''}`}
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          <span className="hamburger-box">
            <span className="hamburger-inner" />
          </span>
        </button>

        <div className={`navbar__links${open ? ' is-open' : ''}`}>
          <Link to="/products" className="navbar__link" onClick={handleLinkClick}>
            Products
          </Link>
          <Link to="/faq" className="navbar__link" onClick={handleLinkClick}>
            FAQ
          </Link>
          <Link to="/about" className="navbar__link" onClick={handleLinkClick}>
            About Us
          </Link>
          <Link to="/contact" className="navbar__link" onClick={handleLinkClick}>
            Contact
          </Link>
          <Link to="/login" className="navbar__link" onClick={handleLinkClick}>
            Log-In
          </Link>
        </div>
      </div>
    </nav>
  );
}
